import { EXPERIENCE, conferenceConfig as currentConferencePhase } from '@fs/zion-rootstech'

export const siteConfig = {
  experience: EXPERIENCE,
  conferencePreviewRedirects: currentConferencePhase.preview.redirects,
}
